import React from "react";

const Overview = ({ eventDetails, token, userID, isLoading }) => {
  // console.log("eventDetails...******", eventDetails);
  return <div className="p-4">Overview</div>;
};

export default Overview;
